import { adminPermision } from "src/constant";

const list = [
	{
		id: adminPermision.noPermision,
		content: 'No Permision'
	},
	{
		id: adminPermision.watch,
		content: 'View Only '
	},
	{
		id: adminPermision.edit,
		content: "Edit"
	}
]

export default list;